import { SCATTER_CHART_PRO_PLUGINS } from '@mui/x-charts-pro/ScatterChartPro';
import type { ScatterChartProPluginSignatures } from '@mui/x-charts-pro/ScatterChartPro';

export type ScatterChartPremiumPluginSignatures = ScatterChartProPluginSignatures;

export const SCATTER_CHART_PREMIUM_PLUGINS = SCATTER_CHART_PRO_PLUGINS;
